import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup, AbstractControl } from '@angular/forms';
import { APILoginService } from '../../_services/login/API-login';
import { APIEntityService } from '../../_services/entity/API-entity';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { formatDate } from '@angular/common';
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Router, ActivatedRoute } from '@angular/router';
//import { objectToFormData } from 'object-to-formdata';

const today = new Date();
var time_today = today.getTime();
var refid = "CID_" + time_today;
const entityId = "EID_" + time_today;


let now = new Date();
const currentdat = formatDate(now, 'yyyy-MM-dd', 'en-US', '+0530');

export interface Id {
  value: string;
  viewValue: string;
}

export interface Item {
  value: string;
  viewValue: string;
}

export interface designation {
  value: string;
  viewValue: string;
}

export interface deportment {
  value: string;
  viewValue: string;
}


@Component({
  selector: 'app-tata-entity-modification',
  templateUrl: './tata-entity-modification.component.html',
  styleUrls: ['./tata-entity-modification.component.css']
})
export class TataEntityModificationComponent implements OnInit {

  disableForm: boolean = false;
  fileSizeError1: boolean = false;
  fileSizeError2: boolean = false;
  PO: boolean;
  RS: boolean;
  PM: boolean;
  tataID:any;
  TTsl_RefNo:any;
 // submitted:boolean=false;
 public response:any
 public checkRole:string;
  processRole:any=[];
  RegistrarStatusRole:any=[];
  selectedOwner:any=[];
  size: number;
  sizepo: any;

  constructor(private fb: FormBuilder,
    private es: APILoginService,
    private ls: APIEntityService,
    private $modal: $ModalManagerService,
    private db: $DBManagerService,
    private _route: ActivatedRoute,
    private router: Router) {
    this._route.params.subscribe((params) => {
      this.tataID = params['id'];
	  console.log("this.tataID", this.tataID)  
    })

  }
  modify:boolean=true;
  // For Principal Entity
  entityForm: FormGroup;
  pePrefix: string = "";
  identifiedVal: string = "";
  rootVal: string = "";
  public Entity_ID_Existing = 'N';
  public IsChild_Org = 'N';
  public Create_Date;
  tataRole: any;
  public HashKYCDoc:any;

  //Registrar_status
  registrarStatus: any = {};
  registrarStatus22:any = {}
  processOwnerroleStatus: any = {};

  // For Tata Employee
  Ttsl_ID: string = "";

  /*  File Upload */
  uploadKYC: string[];

  selectedValue: String;
  processOwner: string[]; 

  lists: string[] = ["aa", "bb", "cc"];  
  lists1: string[] = ["aa", "bb"];  

  processOwner1: string[] = this.lists1
  selected: string[]=[] ;

  //Radio button
  roleCategory: string;

  regProcess = {
    "Process Owner": 2,
    'Registrar': 3,
    'TTL Agent': 5,
    'Preference Manager': 6 
  }
  itemList: Item[] = [
    { value: '2', viewValue: 'Process Owner' },
    { value: '3', viewValue: 'Registrar' },
    { value: '5', viewValue: 'TTL Agent' }, 
    { value: '6', viewValue: 'Preference Manager' } 
  ];

  designations: designation[] = [
    { value: 'SE', viewValue: 'Senior Manager' },
    { value: 'AM', viewValue: 'Assistant Manager' },
    { value: 'DM', viewValue: 'Deputy Manager' },
    { value: 'M', viewValue: 'Manager' },
    { value: 'TL', viewValue: 'Team Lead' },
    { value: 'A', viewValue: 'Associate' },

  ];

//Dropdown for deportments

  deportments: deportment[] = [
    { value: 'RM', viewValue: 'RCM-CC' },
    { value: 'CC', viewValue: 'CSO-SA' },
  ];

  communicationPerf: any;

  public userroles = [];
  public userroles1 = [];

  public assignedRoles = [];
  public ProcessOwnerRole: any;
  public EntityType: any;
  public PEIdentity: any;
  public data: any;
  public Entity_ID = '';
  entCheck;

  submitted: boolean = false;
  public Ttsl_UserName;

  photoName: any;
  photoContent: any;
  fileExtension: any;
  panAlreadyHave;
  fileExtensionError: boolean = false;
  fileExtensionMessage: any;
  get f() { return this.entityForm.controls; }

  myfiles: any[] = [];

  ngOnInit() {

    this.entityForm = this.fb.group({
      Ttsl_Class: ['',],
      Ttsl_ID: ['',],
      Ttsl_UserName: ['',],
      Ttsl_EmailID: ['',],
      Ttsl_MobileNo: ['', [Validators.required, Validators.pattern('^[6-9][0-9]{9}$')]],
      Ttsl_Designation: ['',],
      Ttsl_Department: ['',],
      Ttsl_RoleCategory: ['',],
      Ttsl_ProcessRole: ['',],
      Ttsl_TtlagentRole:['',],
      Ttsl_ProfeManagerRole:['',],
      Ttsl_RegistrarRole: ['',],
      uploadKYC: ['',],
      existEntity_ID: ['',],
      child_Org: ['',],
      Entity_ID: ['',],
      Hash_KYC_Doc: ['',],
      Entity_ID_Existing: ['',],
    });
    this.onModifyPattern()
  }
  regrole:any;
   onRoleChange(item) {
    this.selected=[];
    this.PO = false
    this.RS = false
    console.log("item  : ",item)

    if (this.regProcess[item] == "2") {
      this.PO=true;
    }
    //await this.ls.getProcessRoles(this.regProcess[item])
    var entityID = this.entityForm.get('Ttsl_ID').value;
    console.log("obj.selectedValue", this.regProcess[item]);
    this.entityForm.controls['uploadKYC'].clearValidators();
      this.entityForm.controls['uploadKYC'].setValidators([Validators.nullValidator]);
      this.entityForm.controls['uploadKYC'].updateValueAndValidity();
     this.ls.getProcessRolesModify(this.regProcess[item], entityID) 
      .subscribe(r => { 
        console.log("r : ",r)
        console.log("++++++++++++++++++++++++++++++++++++++++++++++++")
        console.log("this.regProcess[item]  : ",this.regProcess[item] )
        this.userroles = r["_Reg"];
        console.log("this.userroles", this.userroles) 
        var pchk = [];
        this.userroles.forEach( e => {
          if(e.chk) pchk.push(e) 
        })
        this.userroles.forEach(obj=>{
          this.regrole = this.userroles.filter(opt => opt.allowed).map(opt => opt.rid)
        }); 
      //   this.userroles1 = this.userroles.filter(function(item, pos, self) {
      //     return self.indexOf(item.rid) == pos;
      // })
    //   for(let i=0; i < this.userroles.length; i++){
    //     if(this.userroles1.indexOf(this.userroles[i].rid) === -1) {
    //       this.userroles1.push(this.userroles[i]);
    //     }
    // }
      
      console.log("dupl",this.userroles);

      console.log("unic",this.userroles1);
        for(let i=0; i<=this.userroles.length-1;i++){
          for(let j=0;j<=this.RegistrarStatusRole.length-1;j++){
            if(this.RegistrarStatusRole[j] == this.userroles[i].rid){  //When submitted active/pending roles status should not get overwritten whereas he can request for rejected/inactive roles
            this.selected.push(this.userroles[i].rid);
            console.log("this.selected",this.selected)
            }
          }
    }
    
    for(let i=0;i<= this.userroles.length-1;i++){
      for(let j=0;j<=this.processRole.length-1;j++){
      if(this.processRole[j] == this.userroles[i].rid ){
          //this.entityForm.controls['Ttsl_ProcessRole'].setValue(this.processRole);
          this.selectedOwner.push(this.processRole[j]);
      }
      }
    }
        this.processOwner = pchk 
        console.log("pchk : ",pchk);  
        //this.entityForm.controls['Ttsl_ProcessRole'].setValue(["Consent Template Process Owner"]);
        
      }); 
   

    if (this.regProcess[item] === "2") {
      this.entityForm.controls['Ttsl_ProcessRole'].enable();
      this.entityForm.controls['Ttsl_ProcessRole'].updateValueAndValidity();
      this.entityForm.controls['Ttsl_RegistrarRole'].setValue(null)
      this.PO = true
      console.log("thj.po",this.PO)
      this.entityForm.controls['uploadKYC'].clearValidators();
    this.entityForm.controls['uploadKYC'].setValidators([Validators.required]);
    this.entityForm.controls['uploadKYC'].updateValueAndValidity();
     } else if (this.regProcess[item] === "3") {

      this.entityForm.controls['Ttsl_RegistrarRole'].enable(); 
      this.entityForm.controls['Ttsl_RegistrarRole'].setValidators([Validators.required]);
      this.entityForm.controls['Ttsl_RegistrarRole'].updateValueAndValidity();
      this.entityForm.controls['Ttsl_ProcessRole'].setValue(null)
      this.RS = true
    }
  }
   onModifyPattern() { 
    this.PO = false
    this.RS = false
    this.PM = false
	
	console.log("onModifyPattern this.tataID", this.tataID) 
	if(!this.tataID) 
		this.tataID = this.db.get(Constants.SESSSION_STORAGE, Constants.TTSL_ID)  
    
    this.ls.getProcessOwnerDetails(this.tataID)    //commented for testing purpose.
      .subscribe(p => {
        console.log("p : ",p)
        this.registrarStatus = p.Registrar_Status;
        this.registrarStatus22 = p.Registrar_Status;
        this.processOwnerroleStatus = p.Ttsl_ProcessRole; 
        if (p !== null){
          console.log("p.Ttsl_RegistrarRole : ",p.Ttsl_RegistrarRole)
          console.log("p.Ttsl_ProcessRole : ",p.Ttsl_ProcessRole)
        //  this.userroles = p
          
          this.response = p 
          let role;
          console.log("p.Ttsl_Department ",p.Ttsl_Department) 
          this.TTsl_RefNo = p.Ttsl_Ref_No

          console.log(" p.Ttsl_ID", p.Ttsl_ID)  
          console.log("p.Ttsl_UserName ",p.Ttsl_UserName)    
          console.log("pTtsl_ProcessRole : ",p.Ttsl_ProcessRole) 

          this.entityForm.controls['Ttsl_ID'].setValue(p.Ttsl_ID);
          this.entityForm.controls['Ttsl_UserName'].setValue(p.Ttsl_UserName);
          this.entityForm.controls['Ttsl_MobileNo'].setValue(p.Ttsl_MobileNo);
          this.entityForm.controls['Ttsl_Department'].setValue(p.Ttsl_Department);
          this.entityForm.controls['Ttsl_Designation'].setValue(p.Ttsl_Designation);
          this.entityForm.controls['Ttsl_EmailID'].setValue(p.Ttsl_EmailID);
          
          this.entityForm.controls['Ttsl_RoleCategory'].setValue(p.Ttsl_RoleCategory);   // -----    Process Owner or Registrar
        //   this.processRole.push(Object.keys(p.Ttsl_ProcessRole));
        //  console.log("this.processRole" ,this.processRole);
        let processRoles=p.Ttsl_ProcessRole || {};
         for (var key in processRoles) {
           if(processRoles[key]== 'A')
            this.processRole.push(key);
        }

        let RegistrarStatus=p.Registrar_Status || {};
        
        for (var key in RegistrarStatus) {
          if(RegistrarStatus[key]== 'A')
           this.RegistrarStatusRole.push(key);
       }
          if(p.Ttsl_RoleCategory === 'Registrar'){
            this.checkRole='Process Owner';
          }else if(p.Ttsl_RoleCategory === 'Process Owner'){
            this.checkRole='Registrar';
            this.PO=true;

          }
       
          this.onRoleChange(p.Ttsl_RoleCategory || '');
          this.entityForm.controls['Hash_KYC_Doc'].setValue(p.Hash_KYC_Doc); 
          this.HashKYCDoc=p.Hash_KYC_Doc;
          this.entityForm.controls['existEntity_ID'].reset();
          this.entityForm.controls['Entity_ID'].updateValueAndValidity();
        } else {
          this.$modal.errorModal({
            title: 'Entity Modification',
            msg: 'Your Registration is not yet Approved!'
          });
        }
      });

    this.entityForm.controls['existEntity_ID'].reset();

    this.entityForm.controls['Entity_ID'].updateValueAndValidity();
  }
 
  download(file1){ 

    var data = {
      "Entity_ID": this.entityForm.get('Ttsl_ID').value,
      "FileType": "KYC",
      "FileName": file1
    } 
  
  this.ls.headerFileDownload(data).subscribe(r => {
  
    this.downloadFile(r, file1);
    this.$modal.successModal({
      title: 'Entity Summary',
      msg: 'File has been downloaded Successfully'
    });   
  })
  
  }
  private downloadFile(res: any, filename: string): void {
  const url = window.URL.createObjectURL(res);
  const a = document.createElement('a');
  document.body.appendChild(a);
  a.setAttribute('style', 'display: none');
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
  a.remove();
  }
     
  clickedonModify(){
this.modify=false;

  }
  
  // deleteDocument(file1,entityId,file_Hash_KYC_Doc){
  //   var data = {
  //     "Entity_ID": entityId,
  //     "FileType": "KYC",
  //     "FileName": file1,
  //     "file_Hash_KYC_Doc":file_Hash_KYC_Doc
  //   } 
  //   this.ls.deleteBlobIfExists(data).subscribe(r => {
  //     if(r.message=="File Deleted Successfully"){
  
      
  //     this.$modal.successModal({
  //       title: 'Entity Modification',
  //       msg: 'File has been deleted Successfully'
  //     });   
    
  //   }
  //   else if(r.message=="File already deleted"){
  
      
  //     this.$modal.errorModal({
  //       title: 'Entity Modification',
  //       msg: 'File already deleted'
  //     });   
    
  //   }
  //   else{
  
  //     this.$modal.errorModal({
  //       title: 'Entity Modification',
  //       msg: 'File could not be deleted'
  //     });   
    
  //   }
  // })
  // }

  fileEvent(event): any {

    var file = event.target.files[0];
    this.photoName = file.name;

    var allowedExtensions =
      ["jpg", "jpeg", "png", "JPG", "JPEG", "JFIF", "BMP", "SVG"];
    this.fileExtension = this.photoName.split('.').pop();

    if (this.isInArray(allowedExtensions, this.fileExtension)) {
      this.fileExtensionError = false;
      this.fileExtensionMessage = ""
      alert("Invalid File 1 formate");
    } else {
      this.fileExtensionMessage = "Only photos allowed!!"
      alert("Invalid File 2 formate");
      this.fileExtensionError = true;
    }

    if (file) {
      var reader = new FileReader();
      reader.onloadend = (e: any) => {
        var contents = e.target.result;
        this.photoContent = contents;
      }
      reader.readAsDataURL(file);
    } else {
      alert("Failed to load file");
    }
  }

  /*- checks if word exists in array -*/
  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

  entityidAndPan(alreadyHaveEntity, alreadyHavePan) {
    //this.valuechange(alreadyHaveEntity, alreadyHavePan)

  }

  onChangeFileUpload(event) {
    this.PO=false;


    for (var i = 0; i < event.target.files.length; i++) {
      this.myfiles.push(event.target.files[i])


      this.uploadKYC = this.myfiles;

      var file = event.target.files[i];
      this.photoName = file.name;
      if (file.size > 4242880) {
        this.fileSizeError1 = true;
        this.myfiles = [];
      }
      else {
        this.fileSizeError1 = false;
      }
      if (file.size <= 0) {
        this.fileSizeError2 = true;
        this.myfiles = [];
      }
      else {
        this.fileSizeError2 = false;
      }
      var allowedExtensions =
        ["jpg", "jpeg", "png", "JPG", "JPEG", "JFIF", "BMP", "SVG", "pdf", "PNG"];
      this.fileExtension = this.photoName.split('.').pop();
      if (this.isInArray(allowedExtensions, this.fileExtension)) {
        this.fileExtensionError = false;
        this.fileExtensionMessage = ""
      } else {
        this.fileExtensionMessage = "Only photos allowed!!"
        this.fileExtensionError = true;
        this.myfiles = [];
       // this.myfiles.push(event.target.files[i].name);
      }

      if (file) {
        var reader = new FileReader();
        reader.onloadend = (e: any) => {
          var contents = e.target.result;
          this.photoContent = contents;
        }
        reader.readAsDataURL(file);
      } else {
        alert("Failed to load file");
      }
    }

  }

  onChangeRootVal() {
    this.rootVal = this.pePrefix + this.identifiedVal;
  }

  changeEntity(entity) {
    this.EntityType = entity;
  }

  changePEIdentity(peIdentity) {
    this.PEIdentity = peIdentity;
  }


  onSubmit() {
    if (this.entityForm.invalid) {
      this.disableForm = true;

      let invalid = [];  
      let controls = this.entityForm.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          invalid.push(name);
        }
      }
      return;
    }
    else if(this.fileExtensionError || this.fileSizeError2 ||this.fileSizeError1){
      return;
    }
    if (this.entCheck === 'No') {
      this.Entity_ID_Existing = 'N';
      this.Entity_ID = this.entityForm.get("Ttsl_ID").value;
      this.TataModification(this.Entity_ID_Existing, this.IsChild_Org);
    }

    else {
      this.onChangeRootVal();
      this.Entity_ID_Existing = 'Y';
      this.submitted = true;
      if (this.entityForm.invalid) {
        return;    
      }
      else {
        this.TataModification(this.Entity_ID_Existing, this.IsChild_Org);
      }
    }
  }  

  onChangeRole(tataRole) {
    this.tataRole = tataRole.value;
  }
  resetKYC() {                
    console.log(this.entityForm.controls['uploadKYC'].value);  
    this.entityForm.controls['uploadKYC'].reset();
    console.log(this.entityForm.controls['uploadKYC'].value);
    this.uploadKYC = null;

    this.entityForm.controls['uploadKYC'].clearValidators();
    this.entityForm.controls['uploadKYC'].setValidators([Validators.required]);
    this.entityForm.controls['uploadKYC'].updateValueAndValidity();
    this.myfiles = [];
    this.PO=true;
  }

  TataModification(Entity_ID_Existing, IsChild_Org) {
    console.log("TataModificationTataModification",this.myfiles)

    let Ttsl_MobileNo = this.entityForm.get("Ttsl_MobileNo").value;
    let Ttsl_Designation = this.entityForm.get("Ttsl_Designation").value;
    let Ttsl_Department = this.entityForm.get("Ttsl_Department").value;
    let Ttsl_RoleCategory = this.entityForm.get("Ttsl_RoleCategory").value;
    let Ttsl_ProcessRole = this.entityForm.get("Ttsl_ProcessRole").value;
    let Ttsl_RegistrarRole = this.entityForm.get("Ttsl_RegistrarRole").value;
    let Ttsl_EmailID = this.entityForm.get("Ttsl_EmailID").value;

   // let Ttsl_TtlagentRole = this.entityForm.get("Ttsl_TtlagentRole").value; 
   // let Ttsl_ProfeManagerRole = this.entityForm.get("Ttsl_ProfeManagerRole").value;  

    let  Ttsl_ID = this.entityForm.get("Ttsl_ID").value;   

    const entityForm: FormData = new FormData();  

    entityForm.append('Ttsl_MobileNo', Ttsl_MobileNo);
    entityForm.append('Ttsl_Department', Ttsl_Department);
    entityForm.append('Ttsl_Designation', Ttsl_Designation);
    entityForm.append('Ttsl_RoleCategory', Ttsl_RoleCategory);
    //entityForm.append('Ttsl_ProcessRole', Ttsl_ProcessRole);
    entityForm.append('Ttsl_RegistrarRole', Ttsl_RegistrarRole);
    entityForm.append('Ttsl_EmailID', Ttsl_EmailID);

    //entityForm.append('Ttsl_RegistrarRole', Ttsl_TtlagentRole);   
    // entityForm.append('Ttsl_RegistrarRole', Ttsl_ProfeManagerRole);

    

    entityForm.append('Ttsl_ID', Ttsl_ID);
    entityForm.append('TTsl_RefNo', this.TTsl_RefNo);

   console.log("db reg_Status22 : ",this.registrarStatus22);
   console.log("Selected Val : ",this.selected); 

   console.log("db processOwnerroleStatus : ",this.processOwnerroleStatus);
   console.log("PO selectedOwner : ",this.selectedOwner); 

   if(this.processOwnerroleStatus != undefined && this.selectedOwner.length > 0){
      var dbPOkeys22 = Object.keys(this.processOwnerroleStatus).filter(key => this.processOwnerroleStatus[key] == "A")
      this.selectedOwner.concat(Object.keys(this.processOwnerroleStatus).filter(key => this.processOwnerroleStatus[key] == "C" || this.processOwnerroleStatus[key] == "I"))

    
      if(this.selectedOwner.length >= dbPOkeys22.length){
      this.sizepo = this.selectedOwner.length
      }else{
      this.sizepo = dbPOkeys22.length
      }

      for (var i = 0; i < this.sizepo; i++) {
          let uniqPO = dbPOkeys22.indexOf(this.selectedOwner[i]);      
          if((uniqPO < 0) && (this.selectedOwner[i] != undefined)){
            this.processOwnerroleStatus[this.selectedOwner[i]] = "C"
          }else {
            console.log("no change")
          }  
          let uniq2PO = this.selectedOwner.indexOf(dbPOkeys22[i]);   
          if(uniq2PO < 0 && (dbPOkeys22 != undefined)){
            delete this.processOwnerroleStatus[dbPOkeys22[i]]; 
          }        
      } 
    console.log("this.processOwnerroleStatus : ",this.processOwnerroleStatus)  
    entityForm.append('Ttsl_ProcessRole', JSON.stringify(this.processOwnerroleStatus));
    entityForm.append('Registrar_Status', JSON.stringify(this.processOwnerroleStatus));  
  }
  
  
    if(this.registrarStatus22 != undefined && this.selected.length > 0){
      var dbkeys22 = Object.keys(this.registrarStatus22).filter(key => this.registrarStatus22[key] == "A")
      this.selected.concat(Object.keys(this.registrarStatus22).filter(key => this.registrarStatus22[key] == "C" || this.registrarStatus22[key] == "I"))

    console.log("dbkeys22",dbkeys22)
      if(this.selected.length >= dbkeys22.length){
      this.size=this.selected.length
      }else{
      this.size=dbkeys22.length
      }
      for (var i = 0; i < this.size; i++) {
          let uniq = dbkeys22.indexOf(this.selected[i]);      
            if((uniq < 0) && (this.selected[i] != undefined)){
              this.registrarStatus22[this.selected[i]] = "C"
            }else {
              console.log("no change")
            }  
            let uniq2 = this.selected.indexOf(dbkeys22[i]);   
            if(uniq2 < 0 && (dbkeys22 != undefined)){
              delete this.registrarStatus22[dbkeys22[i]]; 
            }        
        } 
      console.log("this.registrarStatus22 : ",this.registrarStatus22)  
      entityForm.append('Registrar_Status', JSON.stringify(this.registrarStatus22));  
    }
    
    //var Registrar_Status = 'Registrar_Status' + '.' + Ttsl_RegistrarRole
    const file1: any = document.getElementById('uploadKYC');

    for (var i = 0; i <= this.myfiles.length; i++) {
      entityForm.append('file'[i], this.myfiles[i]);
    }

    entityForm.append('Entity_ID_Existing', Entity_ID_Existing);
    entityForm.append('Create_Date', currentdat);
   // entityForm.append('E_Org_Name', 'TATA Tele');
    entityForm.append('Ttsl_Class', "Tata Employee");

    this.ls.tataModification(entityForm)
      .subscribe(r => {
        console.log("modification result : " ,r)
        try {
          if (r.status == "success") {
            this.$modal.successModal({
              title: 'Modification',
              msg: 'Your request for Tata Employee Modification has been sent for Approval. Your Service Request Number is '+r.srno
            });
          }
         else if (r.message=="Mobile exists") { 
            this.$modal.errorModal({
              title: 'Registration',
              msg: 'Mobile number already exists!'
            });
          }            
        }
        catch (e) {          
            this.$modal.errorModal({
              title: 'Error',
              msg: 'Error Occured ' +e
            });       
        }
      });
  }

  public validKyc;
  public errmsg;

}
export function noWhiteSpace(control: AbstractControl) {

  var data = control.value;

  if (data == " " || data.charAt(0) === " " || data.charAt(data.length - 1) === " ") {

    return { validUrl: true };

  }
  return null;
}
